import React from "react";
import { Package, Boxes, Truck, BadgeDollarSign, MessageCircle, Phone } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { links } from "../lib/api";
import { Container, Reveal, ContactPills } from "../components/site/Reveal";
import { Brands } from "../components/home/ProductSections";
import { Contact } from "../components/home/InfoSections";
import { usePageMeta } from "../lib/seo";

export const PageHero = ({ eyebrow, title, text, children }) => (
  <section className="relative overflow-hidden bg-[linear-gradient(180deg,#eefbf8,#ffffff)] py-16 md:py-20">
    <div className="pointer-events-none absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full bg-[#c9f5ec]/60 blur-3xl" />
    <Container className="relative">
      <div className="sw-fade-up max-w-[760px]">
        <div className="sw-section-eyebrow">{eyebrow}</div>
        <h1 className="mt-3 font-jakarta text-[40px] md:text-[54px] font-extrabold leading-[1.08] tracking-[-0.03em] text-[#0f2e2a]">{title}</h1>
        <p className="mt-4 text-[18px] leading-relaxed text-[#4b5d5a]">{text}</p>
        {children}
        <ContactPills center={false} />
      </div>
    </Container>
  </section>
);

const PERKS = [
  [Boxes, "Any Quantity", "From a few boxes to full cases, we're happy to take a look."],
  [BadgeDollarSign, "Volume Pricing", "Larger sealed lots may qualify for a better offer per box."],
  [Truck, "Free Shipping", "Prepaid labels for every accepted order, big or small."],
  [Package, "Careful Inspection", "We check every item and keep you updated until payment is sent."],
];

const Bulk = () => {
  const { content, openChat, t } = useSite();
  const l = links(content);
  usePageMeta({ title: "Bulk Quotes for Sealed Testing Supplies | Nationwide | StripWise", description: "Have a large quantity of sealed, unexpired testing supplies? Get a free bulk quote from StripWise with prepaid shipping and friendly support across the USA.", path: "/bulk" });
  return (
    <>
      <PageHero eyebrow={t("We Buy in Bulk")} title={t("Selling a Larger Quantity?")} text={t("Have a large number of sealed, unexpired supplies? {brand} offers free bulk quotes, prepaid shipping and one-on-one help.", { brand: content?.brand })}>
        <div className="mt-7 flex flex-wrap gap-3">
          <button onClick={() => openChat(t("Hi! I have a bulk order to sell."))} className="sw-btn-primary" data-testid="bulk-chat-btn"><MessageCircle size={16} /> {t("Get a Bulk Quote")}</button>
          <a href={l.tel} className="sw-btn-outline"><Phone size={16} /> {content?.phone_display}</a>
        </div>
      </PageHero>
      <section className="py-16">
        <Container className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PERKS.map(([I, title, d], idx) => (
            <Reveal key={title} delay={idx * 90} className="sw-card p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[linear-gradient(135deg,#12a593,#0b6f65)] text-white"><I size={20} /></span>
              <h3 className="mt-5 text-[18px] font-bold text-[#0f2e2a]">{t(title)}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-[#566865]">{t(d)}</p>
            </Reveal>
          ))}
        </Container>
      </section>
      <div className="bg-[#f4fbf9]"><Brands /></div>
      <Contact />
    </>
  );
};

export default Bulk;
